import { NacionalidadeEnum } from "./enums/NacionalidadeEnum";
import { EstadoCivilEnum } from "./enums/EstadoCivilEnum";
import { SituacaoEnum } from "./enums/SituacaoEnum";
import { SexoEnum } from "./enums/SexoEnum";
var RequerentePf = /** @class */ (function () {
    function RequerentePf() {
        this.estadoCivil = EstadoCivilEnum.SOLTEIRO;
        this.informarNomeSocial = false;
        this.sexo = SexoEnum.MASCULINO;
        this.falecido = false;
        this.atendimentoPrioritario = false;
        this.advogado = false;
        this.cpf = "";
        this.nome = "";
        this.nomeSocial = "";
        this.informarNomeSocial = false;
        this.sexo = SexoEnum.MASCULINO;
        this.dataNascimento = null;
        this.nacionalidade = NacionalidadeEnum.BRASILEIRO;
        this.profissao = "";
        this.estadoCivil = EstadoCivilEnum.SOLTEIRO;
        this.celular = "";
        this.telefone = "";
        this.email = "";
        this.estado = null;
        this.cep = "";
        this.endereco = "";
        this.numero = "";
        this.complemento = "";
        this.bairro = "";
        this.municipio = null;
        this.situacao = SituacaoEnum.ATIVO;
        this.justificativa = "";
        this.falecido = false;
        this.advogado = false;
        this.ufOAB = null;
        this.numeroOAB = "";
        this.conjuge = {
            cpf: "",
            nome: "",
            dataNascimento: null,
            informarNomeSocial: false,
            nomeSocial: "",
            sexo: SexoEnum.MASCULINO,
            nacionalidade: NacionalidadeEnum.BRASILEIRO,
            profissao: "",
            estadoCivil: EstadoCivilEnum.SOLTEIRO,
            celular: "",
            telefone: "",
            email: "",
            estado: null,
            cep: "",
            endereco: "",
            numero: "",
            complemento: "",
            bairro: "",
            municipio: null,
            situacao: SituacaoEnum.ATIVO,
            justificativa: "",
            falecido: false,
            advogado: false,
            ufOAB: null,
            numeroOAB: "",
            conjuge: null,
        };
    }
    return RequerentePf;
}());
export { RequerentePf };
var RequerentePfError = /** @class */ (function () {
    function RequerentePfError() {
    }
    return RequerentePfError;
}());
export { RequerentePfError };
